export default __webpack_public_path__ + "static/media/ferrero-rocher.7067a196.png";